module.exports = __webpack_public_path__ + "img/new-card.c590d2a0.svg";